export default "__VITE_ASSET__6_tGyCW___"